const removeGid = (str: string) => {
    return str.replace('gid://shopify/Product/', '').replace('gid://shopify/ProductVariant/', '');
}

const isNewShopifyProductVersionId = (id: string | number) => {
    try {
        return typeof id === 'string' && id.includes('gid://shopify/');
    } catch(error) {
        return false;
    }
}

export const shopifyIdNumber = (id: string | number) => {
    if(isNewShopifyProductVersionId(id) && typeof id === 'string') {
        return removeGid(id);
    } else return id;
}